
const logout = () => {
    localStorage.removeItem('AUTH_TOKEN')
    localStorage.removeItem('AUTH_USER')
    location.reload()
}

export {
    logout
}